angular.module('FlexyBeautyApp.services').factory('Environment_Constant', [
    function () {
        return {
            VERSION_CHECK_FREQUENCY_MILLISECOND: 30 * 60 * 1000,
        };
    }
]);

angular.module('FlexyBeautyApp.services').factory('Environment_Resource', [
    "$resource", "$location",
    function ($resource, $location) {
        let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
        return $resource(baseUrl + 'rest/environment', {}, {
            getVersion: {method: 'GET', url: baseUrl + 'rest/environment/version'},
        });
    }
]);

angular.module('FlexyBeautyApp.services').factory('Environment', [
    "Environment_Resource", "EnvironmentData",
    function (Environment_Resource, EnvironmentData) {

        let Environment = function (resource) {
            this.version = null;
            if (resource) {
                this.loadObject(resource);
            }
            EnvironmentData.set(this);
        };

        Environment.prototype.loadObject = function (resource) {
            this.version = resource.version;
        };

        return Environment;
    }
]);

angular.module('FlexyBeautyApp.services').factory('EnvironmentSrv', [
    'Environment_Resource', 'EnvironmentData', 'Environment',
    function (Environment_Resource, EnvironmentData, Environment) {
        let environmentSrv = {};

        environmentSrv.getVersion = async function () {
            return await Environment_Resource.getVersion().$promise.then(
                versionResponse => {
                    let versionObject = versionResponse.toJSON();
                    let environment = EnvironmentData.get();
                    if (!environment) {
                        environment = new Environment(versionObject);
                    } else {
                        environment.loadObject(versionObject);
                    }
                    return environment.version;
                });
        }
        return environmentSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('EnvironmentData', [
    function () {
        let environmentData = {
            environment: undefined
        };

        environmentData.get = function () {
            return this.environment;
        }

        environmentData.set = function (environment) {
            this.environment = environment;
            return this.environment;
        }

        return environmentData;
    }
]);



// WEBPACK FOOTER //
// ./js/services/models/Environment.js